import React, { Fragment, useEffect, useState } from 'react';
import { Link, NavLink, useMatch, useNavigate } from 'react-router-dom';
import { Menu, Transition } from '@headlessui/react';
import { Building2, ChevronDown, LogOut, User } from 'lucide-react';
import { mandantenAPI } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';

function MandantSwitcher({ currentSlug }) {
  const navigate = useNavigate();
  const [mandanten, setMandanten] = useState([]);
  const [current, setCurrent] = useState(null);

  useEffect(() => {
    mandantenAPI.list().then((r) => {
      setMandanten(r.data);
      setCurrent(r.data.find((m) => m.slug === currentSlug) || null);
    }).catch(() => {});
  }, [currentSlug]);

  if (!current) return null;

  return (
    <Menu as="div" className="mandant-switcher">
      <Menu.Button className="switcher-button">
        <Building2 size={14} />
        <span>{current.name}</span>
        <span className="muted small">{current.skr_variant}</span>
        <ChevronDown size={12} />
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="fade-enter" enterFrom="fade-enter-from" enterTo="fade-enter-to"
        leave="fade-leave" leaveFrom="fade-leave-from" leaveTo="fade-leave-to"
      >
        <Menu.Items className="switcher-items">
          {mandanten.map((m) => (
            <Menu.Item key={m.id}>
              {({ active }) => (
                <button
                  className={`switcher-item ${active ? 'active' : ''} ${m.slug === currentSlug ? 'current' : ''}`}
                  onClick={() => navigate(`/mandanten/${m.slug}/belege`)}
                >
                  <span className="switcher-name">{m.name}</span>
                  <span className="muted small">{m.skr_variant}</span>
                </button>
              )}
            </Menu.Item>
          ))}
          <div className="switcher-divider" />
          <Menu.Item>
            {({ active }) => (
              <button
                className={`switcher-item ${active ? 'active' : ''}`}
                onClick={() => navigate('/mandanten')}
              >
                Alle Mandanten
              </button>
            )}
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}

function UserMenu() {
  const { user, logout } = useAuth();
  if (!user) return null;
  return (
    <Menu as="div" className="user-menu">
      <Menu.Button className="switcher-button">
        <User size={14} />
        <span>{user.email}</span>
        <ChevronDown size={12} />
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="fade-enter" enterFrom="fade-enter-from" enterTo="fade-enter-to"
        leave="fade-leave" leaveFrom="fade-leave-from" leaveTo="fade-leave-to"
      >
        <Menu.Items className="switcher-items right">
          <div className="switcher-info">
            <div className="switcher-name">{user.email}</div>
            <div className="muted small">{user.role}</div>
          </div>
          <div className="switcher-divider" />
          <Menu.Item>
            {({ active }) => (
              <button
                className={`switcher-item ${active ? 'active' : ''}`}
                onClick={logout}
              >
                <LogOut size={14} /> Abmelden
              </button>
            )}
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}

export default function TopNav() {
  const mandantMatch = useMatch('/mandanten/:slug/*');
  const slug = mandantMatch?.params.slug;

  return (
    <nav className="topnav">
      <div className="topnav-inner">
        <div className="topnav-left">
          <Link to="/mandanten" className="brand">
            Schiffer<span className="brand-accent">AutoFIBU</span>
          </Link>
          {slug && <MandantSwitcher currentSlug={slug} />}
          {slug && (
            <div className="topnav-tabs">
              <NavLink to={`/mandanten/${slug}/belege`} className={({isActive}) => `tab ${isActive ? 'active' : ''}`}>
                Eingang
              </NavLink>
              <NavLink to={`/mandanten/${slug}/ausgang`} className={({isActive}) => `tab ${isActive ? 'active' : ''}`}>
                Ausgang
              </NavLink>
              <NavLink to={`/mandanten/${slug}/journal`} className={({isActive}) => `tab ${isActive ? 'active' : ''}`}>
                Journal
              </NavLink>
              <NavLink to={`/mandanten/${slug}/bank`} className={({isActive}) => `tab ${isActive ? 'active' : ''}`}>
                Bank
              </NavLink>
              <NavLink to={`/mandanten/${slug}/reports`} className={({isActive}) => `tab ${isActive ? 'active' : ''}`}>
                Reports
              </NavLink>
              <NavLink to={`/mandanten/${slug}/kunden`} className={({isActive}) => `tab ${isActive ? 'active' : ''}`}>
                Kunden
              </NavLink>
              <NavLink to={`/mandanten/${slug}/lieferanten`} className={({isActive}) => `tab ${isActive ? 'active' : ''}`}>
                Lieferanten
              </NavLink>
            </div>
          )}
        </div>
        <div className="topnav-right">
          <UserMenu />
        </div>
      </div>
    </nav>
  );
}
